"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
const UiBaseElement_1 = require("../ui/UiBaseElement");
const UiElements_1 = require("../ui/UiElements");
class Toast extends UiBaseElement_1.UIBaseElement {
    static create(type, text, duration = 2000) {
        const parentEl = document.getElementById("toastPlaceholder");
        const toast = new UiElements_1.DivEl();
        toast.setClass('c-toast ' + type);
        const contentDiv = new UiElements_1.DivEl().setInnerHTML(text);
        toast.addChild(contentDiv);
        parentEl === null || parentEl === void 0 ? void 0 : parentEl.appendChild(toast.domEl);
        setTimeout(() => {
            this.show(toast, duration);
        }, 50);
    }
    static show(toast, duration) {
        toast.setStyle({
            bottom: ((45 * this.numberOfToasts) + 20) + 'px',
        });
        this.numberOfToasts++;
        setTimeout(() => {
            this.hide(toast);
        }, duration);
    }
    static hide(toast) {
        toast.setStyle({ bottom: '-' + (40 * this.numberOfToasts) + 'px' });
        setTimeout(() => {
            toast.domEl.remove();
            this.numberOfToasts--;
        }, 1000);
    }
}
exports.Toast = Toast;
Toast.numberOfToasts = 0;
